import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { UserLoginData } from './session.state';
import { User } from 'src/app/core/models/user.model';

export const SessionActions = createActionGroup({
  source: 'Session',
  events: {
    login_start: props<{ userLoginData: UserLoginData }>(),
    login_success: props<{ user: User }>(),
    login_fail: props<{ error: any }>(),
    get_user_start: emptyProps(),
    get_user_success: props<{ user: User }>(),
    get_user_fail: props<{ error: any }>(),
    logout: emptyProps(),
    no_op: emptyProps()
  }
});
